'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$ByCredentialAndDocumentType(hash, doctype) {
  this.XT = null;
  this.XS = null;
  this.XT = hash;
  this.XS = doctype;
}
export { $c_Lpresto_GroupsView$ByCredentialAndDocumentType as $c_Lpresto_GroupsView$ByCredentialAndDocumentType };
$p = $c_Lpresto_GroupsView$ByCredentialAndDocumentType.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$ByCredentialAndDocumentType;
/** @constructor */
function $h_Lpresto_GroupsView$ByCredentialAndDocumentType() {
}
export { $h_Lpresto_GroupsView$ByCredentialAndDocumentType as $h_Lpresto_GroupsView$ByCredentialAndDocumentType };
$h_Lpresto_GroupsView$ByCredentialAndDocumentType.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_GroupsView$ByCredentialAndDocumentType)) {
    if ((this.XT === x$0.XT)) {
      var x = this.XS;
      var x$2 = x$0.XS;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ByCredentialAndDocumentType";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.XT;
  }
  if ((n === 1)) {
    return this.XS;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_GroupsView$ByCredentialAndDocumentType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iq)));
}
export { $isArrayOf_Lpresto_GroupsView$ByCredentialAndDocumentType as $isArrayOf_Lpresto_GroupsView$ByCredentialAndDocumentType };
var $d_Lpresto_GroupsView$ByCredentialAndDocumentType = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$ByCredentialAndDocumentType, "presto.GroupsView$ByCredentialAndDocumentType", ({
  iq: 1,
  K9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_GroupsView$ByCredentialAndDocumentType as $d_Lpresto_GroupsView$ByCredentialAndDocumentType };
//# sourceMappingURL=presto.-Groups-View$-By-Credential-And-Document-Type.js.map
